import React, { useState, useEffect } from "react";
import F1 from "../../Assessts/Images/Banners/Frame1.png";
import F2 from "../../Assessts/Images/Banners/Frame2.png";
import F3 from "../../Assessts/Images/Banners/Frame3.png";
import IOText from "../../ReUableComponents/ImageOntext";
// import { FaRegPaperPlane } from "react-icons/fa";
// import { BiParagraph } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
const SlidingFrame = () => {
    const navigate = useNavigate();
    const [Index, SetIndex] = useState(1);
    const Data = [
        {
            Image: F1,
            text: <div className="Text-MainDiv" >
                <div> “Empowering Learning Through
                    Competency-Based Assessments”</div>
                <div className="mt-2 mb-2 Text-Content">
                    NCP helps students demonstrate true understanding through curriculum-aligned, competency-based learning and evaluation.
                </div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={() => navigate("/Competency Base Learning")}>Learn About NCP</button>
            </div>,
        },
        {
            Image: F2,
            text: <div className="Text-MainDiv" >
                <div>“Move Beyond Rote Learning”</div>
                <div className="mt-2 mb-2 Text-Content ">
                    NCP focuses on evaluating concepts, skills, and application—helping learners progress through mastery, not memorization.
                </div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={() => navigate("/Competency Base Learning")}>Learn About NCP</button>
            </div>
        },
        {
            Image: F3,
            text: <div className="Text-MainDiv" >
                <div>“Enabling Learning Through SADHANA,
                    SODHANA, and SAMAGRA Assessment”</div>
                <div className="mt-2 mb-2 Text-Content">
                    The NSF Competency Program (NCP) supports competency-based learning through structured Sadhana, Sodhana, and Samagra assessments. </div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={() => navigate("/Competency Base Learning")}>Learn About NCP</button>
            </div>
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            SetIndex((prev) => (prev + 1) % Data.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="mt-2" style={{ position: "relative" }}>
            <div>
                <IOText Image={Data[Index].Image} Alt="EMpower" Text={Data[Index].text} />
            </div>
            <div className="dflex gap-3 JCCenter All_Dots">
                {Data.map((_, i) => (
                    <button key={i} onClick={() => SetIndex(i)}
                        className={`DOts ${i === Index ? "Dots-Active" : ""}`} />
                ))}
            </div>
        </div>
    )
}
export default SlidingFrame;